import { hasValue } from '../helper/has-value.helper';

export function validateHasValue(value: any): boolean {
  return hasValue(value);
}
